import React, {useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
const EditDepartments = () => {
 // const { id } = useParams();
 useEffect(() => {
         const scriptUrls = [
           'assets/js/jquery.min.js',
           'assets/js/bootstrap.bundle.min.js',
           'assets/js/moment.min.js',
           'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
           'assets/vendor/overlay-scroll/custom-scrollbar.js',
           'assets/vendor/daterange/daterange.js',
           'assets/vendor/daterange/custom-daterange.js',
           'assets/vendor/jquery-ui/jquery-ui.min.js',
           'assets/vendor/jquery-ui/custom.js',
           //'assets/vendor/apex/apexcharts.min.js',
           //'assets/vendor/apex/custom/home/patients.js',
           //'assets/vendor/apex/custom/home/department-income.js',
           //'assets/vendor/apex/custom/home/income.js',
           //'assets/vendor/apex/custom/home/appointments-overview.js',
           //'assets/vendor/apex/custom/home/sparklines.js',
           'assets/vendor/datatables/dataTables.min.js',
           'assets/vendor/datatables/dataTables.bootstrap.min.js',
           'assets/vendor/datatables/custom/custom-datatables.js',
           'assets/js/custom.js'
         ];
     
         let isCancelled = false;
     
         // Load scripts sequentially
         const loadScriptsSequentially = async () => {
           for (const url of scriptUrls) {
             if (isCancelled) break;
     
             await new Promise((resolve, reject) => {
               const script = document.createElement('script');
               script.src = url;
               script.onload = resolve;
               script.onerror = reject;
               document.body.appendChild(script);
             });
           }
         };
     
         loadScriptsSequentially();
     
         return () => {
           isCancelled = true;
           // Optionally remove scripts if needed
         };
       }, []);
  const navigate = useNavigate(); // For navigation
  const location = useLocation();
  const uata = location.state?.uata;
  const [department, setDepartment] = useState([]);
  const [depName, setDepName] = useState('');
  const [depEmail, setDepEmail] = useState('');
  const [depHead, setDepHead] = useState('');
  const [depPhone, setDepPhone] =useState('');
  const [noRooms, setNoRooms] = useState('');
  const [noBeds, setNoBeds] =useState('');
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');
  useEffect(() =>{
    const REST_API_BASE_URL = `http://localhost:8080/api/listBooks/${uata}`;
    const departmentById =() => axios.get(REST_API_BASE_URL);
    departmentById().then((response) => {
      const departmentData = response.data;
      setDepartment(departmentData);
      setDepName(departmentData.depName);
      setDepEmail(departmentData.depEmail);
      setDepHead(departmentData.setDepHead);
      setDepPhone(departmentData.depPhone);
      setNoRooms(departmentData.noRooms);
      setNoBeds(departmentData.noBeds);
      setStatus(departmentData.status);
      setMessage(departmentData.message);
        
    }).catch(error =>{
        window.alert(error+" "+uata);
        
    })
} , [])
  const handleUpdate = (e) => {
    // Prevent default form submission
    e.preventDefault();

    // Show confirmation dialog
    const confirmUpdate = window.confirm(
      `Are you sure you want to update item with ID: ${uata}?`
    );

    if (confirmUpdate) {
      // If confirmed, perform the update action
      
      const formData = new FormData();
      formData.append("jsonData" , JSON.stringify({
        
        "dep_name":depName,
        "dep_email":depEmail,
        "dep_head":depHead,
        "dep_phone":depPhone,
        "no_rooms":noRooms,
        "no_beds":noBeds,
        "status":status,
        "message":message
        
      }));
      
      console.log();
      const REST_API_BASE_URL = `http://localhost:8080/api/insBookById/${uata}`;
      const updateWithIds=(formData) => axios.put(REST_API_BASE_URL,formData);
      updateWithIds(formData)
        .then((response) => {
          console.log(response.data);
          window.alert(`Successfully updation done with ${uata}`);
          
          // After deletion, redirect to another page (e.g., home or item list)
          navigate("/booklist"); // Navigates back to the homepage or another route
        })
        .catch((error) => {
          window.alert("Error occurred while updating the item.");
          console.error(error);
        });
    } else {
      // If cancelled, do nothing (or show a cancellation message)
      window.alert("Updation cancelled");
      navigate("/departments-list");
    }
  };
 

  return (
    <div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="index-2.html">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item">Department</li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        Edit Department
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div>
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">Edit Department</h5>
          </div>
          <div className="card-body">
            {/* Row starts */}
            <div className="row gx-4">
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a1">Department Name</label>
                  <input type="text" className="form-control" id="a1" defaultValue={department.depName} onChange={(e)=>setDepName(e.target.value)}/>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a2">Department Email</label>
                  <input type="email" className="form-control" id="a2" defaultValue={department.depEmail} onChange={(e)=>setDepEmail(e.target.value)}/>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a3">Department Head</label>
                  <input type="text" className="form-control" id="a3" defaultValue={department.depHead} onChange={(e)=>setDepHead(e.target.value)}/>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a4">Department Phone</label>
                  <input type="text" className="form-control" id="a4" defaultValue={department.depPhone} onChange={(e)=>setDepPhone(e.target.value)}/>
                </div>
              </div>
              {/* <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a5">Number of Rooms</label>
                  <select className="form-select" id="a5" defaultValue={department.noRooms} onChange={(e)=>setNoRooms(e.target.value)}>
                    <option value={0}>3</option>
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                  </select>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a6">Number of Beds</label>
                  <select className="form-select" id="a6" defaultValue={department.noBeds} onChange={(e)=>setNoBeds(e.target.value)}>
                    <option value={0}>8</option>
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                  </select>
                </div>
              </div> */}
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="inlineRadio1">Status</label>
                  <div className="m-0">
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" defaultChecked defaultValue={department.status} onChange={(e)=>setStatus(e.target.value)}/>
                      <label className="form-check-label" htmlFor="inlineRadio1">Active</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" defaultValue={department.status} onChange={(e)=>setStatus(e.target.value)}/>
                      <label className="form-check-label" htmlFor="inlineRadio2">Inactive</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a7">Message</label>
                  <textarea className="form-control" id="a7" placeholder="Enter message" rows={3} defaultValue={department.message} onChange={(e)=>setMessage(e.target.value)} />
                </div>
              </div>
              <div className="col-sm-12">
                <div className="d-flex gap-2 justify-content-end">
                  <a href="#!" className="btn btn-outline-secondary">
                    Cancel
                  </a>
                  <button type="submit" className="btn btn-primary" onClick={handleUpdate}>
                    Update Department
                  </button>
                </div>
              </div>
            </div>
            {/* Row ends */}
          </div>
        </div>
      </div>
    </div>
    {/* Row ends */}
  </div>
  {/* App body ends */}
</div>

  );
};

export default EditDepartments;

